<template>
  <div>
    RSI: {{ rule.config.term }} periods, {{ rule.config.above_below }}
    <span
      v-if="
        rule.config.above_below == 'above' ||
        rule.config.above_below == 'below' ||
        rule.config.above_below == 'crossed below' ||
        rule.config.above_below == 'crossed above'
      "
      >,
      {{ rule.config.threshold }}
    </span>

    <span
      v-if="
        rule.config.above_below == 'bullish divergence' ||
        rule.config.above_below == 'bearish divergence'
      "
      >, {{ rule.config.days }} days lookback. Last RSI between {{ rule.config.threshold }} and
      {{ rule.config.threshold_max }}
    </span>
    <span
      v-if="
        rule.config.above_below == 'trending up last XX days' ||
        rule.config.above_below == 'trending down last XX days'
      "
      >, {{ rule.config.days }} days lookback. Last RSI between {{ rule.config.threshold }} and
      {{ rule.config.threshold_max }}
    </span>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {}
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
